<template>
    <!-- 左边导航[[ -->
    <div class="g-menu g-autofixheight">
        <router-link class="personal-center menu-title" style="display: block;"
            active-class="personal-center-active" :to="{name: 'v4-personal-personal'}"
            v-show="!roleId || roleId!==40">
            <div class="menu-title-icon" style="margin-top:10px">
                <i class="ico ico-personal"></i>
            </div>
            <span class="menu-title-name" href="javascript:;">首页</span>
            <i class="ico-red-tips" v-if="tips > 0"></i>
        </router-link>
        <!-- 个人中心 end -->

        <ul class="menu-bar">
            <template v-if="roleId && roleId !== 40">
                <li class="menu-group">
                    <div class="menu-title">
                        <div class="menu-title-icon">
                            <i class="ico ico-work"></i>
                        </div>
                        <div class="menu-title-name">创作</div>
                    </div>
                    <router-link class="menu-item"
                        :class="{'menu-item-active': $route.name.includes('v4-order')}"
                        active-class="menu-item-active" :to="{name: 'v4-order-personal'}">订单投稿</router-link>
                </li>
                <li class="menu-group">
                    <div class="menu-title">
                        <div class="menu-title-icon">
                            <i class="ico ico-manage"></i>
                        </div>
                        <div class="menu-title-name">管理</div>
                    </div>
                    <router-link class="menu-item" active-class="menu-item-active"
                        :to="{name: 'v4-manage-content'}">我的内容</router-link>
                </li>
                <li class="menu-group">
                    <div class="menu-title">
                        <div class="menu-title-icon">
                            <i class="ico ico-data"></i>
                        </div>
                        <div class="menu-title-name">数据</div>
                    </div>
                    <router-link class="menu-item" active-class="menu-item-active"
                        :to="{name: 'v4-information-content'}">内容数据</router-link>
                </li>
                <li class="menu-group">
                    <div class="menu-title">
                        <div class="menu-title-icon">
                            <i class="ico ico-income"></i>
                        </div>
                        <div class="menu-title-name">收益</div>
                    </div>
                    <router-link class="menu-item" active-class="menu-item-active"
                        :to="{name: 'v4-profit-profit'}">收益结算</router-link>
                </li>
                <li class="menu-group">
                    <div class="menu-title">
                        <div class="menu-title-icon">
                            <i class="ico ico-lab"></i>
                        </div>
                        <div class="menu-title-name">实验室</div>
                    </div>
                    <router-link class="menu-item" v-if="hasAuth"
                        :class="{'menu-item-active': $route.name.includes('v4-extension')}"
                        active-class="menu-item-active" :to="{name: 'v4-extension-manage'}">游戏推广</router-link>
                </li>
                <li class="menu-group">
                    <div class="menu-title">
                        <div class="menu-title-icon">
                            <i class="ico ico-set"></i>
                        </div>
                        <div class="menu-title-name">设置</div>
                    </div>
                    <router-link class="menu-item" active-class="menu-item-active"
                        :to="{name: 'v4-set-account'}">账户设置</router-link>
                </li>
            </template>
        </ul>
        <p class="helper">小助手QQ：839864279</p>
    </div>
    <!-- 左边导航]] -->
</template>
<style lang="scss" scoped>
.helper {
    font-size: 14px;
    line-height: 1;
    text-align: center;
}
.ico-red-tips {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #ff2500;
    position: absolute;
    right: 30px;
    top: 50%;
    margin-top: -5px;
}
</style>

<script>
import {
    mapGetters
} from 'vuex';
export default {
    data() {
        return {
            roleId: ''
        }
    },
    computed: {
        ...mapGetters([
            'noticeList',
            'hasAuth'
        ]),
        tips() {
            return this.noticeList.filter((item) => {
                return item.tag.toLowerCase().includes('new')
            }).length
        }
    },
    created() {
        this.roleId = this.$store.state.realUserInfo.roleId;
    }
}
</script>